module.exports = __webpack_public_path__ + "img/logo.7335c0f.png";